// PreviewLoop loader entry.
// Embed: <script src="https://cdn.previewloop.com/loader.js" data-project="pk_xxx" defer></script>
// Optional: data-api="https://api.your-host.com" to override the API origin.

import { mountWidget, type WidgetConfig } from "@previewloop/widget-core";
import { captureViewport } from "./capture";

const DEFAULT_API_ORIGIN = "https://api.previewloop.com";
const SCRIPT_TAG_QUERY = "script[data-project]";

function resolveConfig(): WidgetConfig | null {
  const current = document.currentScript as HTMLScriptElement | null;
  const el = current ?? document.querySelector<HTMLScriptElement>(SCRIPT_TAG_QUERY);
  const projectKey = el?.dataset.project;
  if (!projectKey) return null;
  return { projectKey, apiOrigin: el?.dataset.api ?? DEFAULT_API_ORIGIN };
}

export function init(): void {
  const config = resolveConfig();
  if (!config) {
    console.warn("[PreviewLoop] missing data-project on the script tag; widget disabled.");
    return;
  }
  const start = (): void => {
    mountWidget(config, { captureScreenshot: captureViewport });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
}

init();
